export default (value, object) => {
  if(isNaN(value))
    return ''

  let amount_BGN, amount_EUR

  if(object && object.currency === 'EUR') {
    amount_BGN = parseFloat(value * window.BGN_EURO_RATE).toFixed(2)
    amount_EUR = parseFloat(value).toFixed(2)
    return amount_EUR + '€'
  } else {
    amount_BGN = parseFloat(value).toFixed(2)
    amount_EUR = parseFloat(value / window.BGN_EURO_RATE).toFixed(2)
    return amount_BGN + 'лв'
  }

  // return amount_BGN + 'лв/' + amount_EUR + '€'
}
